export function formatReportCurrency(value: string | number): string {
    const num =
        typeof value === 'number'
            ? value
            : (() => {
                  const parsed = Number.parseFloat(value);
                  return Number.isNaN(parsed) ? 0 : parsed;
              })();

    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(num);
}

export function formatReportPercent(value: string | number): string {
    const num =
        typeof value === 'number'
            ? value
            : (() => {
                  const parsed = Number.parseFloat(value);
                  return Number.isNaN(parsed) ? 0 : parsed;
              })();

    return `${num.toFixed(1)}%`;
}
